import { Component, Input, OnInit } from '@angular/core';
import { FingerPlacement } from './FingerPlacement';
import { Chord } from './Chord';
import { HttpClient } from '@angular/common/http';
import { ChordCalc } from './ChordCalc';

@Component({
  selector: 'app-chord-render',
  templateUrl: './Render.html',
  styleUrls: ['./Render.css']
})
export class AppChordRender implements OnInit {
  private static _chordConfig: { [index: string]: Chord } = {};
  private static _download: { [index: string]: number } = {};

  @Input() public instrument: string = 'guitar';
  @Input() public chord: string = 'C';
  @Input() public graph: boolean = false;
  @Input() public size: number = 100;
  @Input() public level: number = 1;

  public height = 120;
  public width = 100;
  public frets: number[] = [1, 2, 3, 4];

  constructor(private readonly http: HttpClient) {
    // this.loadChord('U');
  }

  ngOnInit(): void {
    this.loadChord(this.chord);
  }

  private getChordIndex(chordname: string = 'U') {
    return chordname
      + (this.level !== 1 ? ('+' + (this.level - 1)) : '');
  }

  private loadChord(chordname: string = 'U') {
    const chordIndex = this.getChordIndex(chordname);
    let now = new Date().getTime();
    if (!AppChordRender._chordConfig[chordIndex] && (!AppChordRender._download[chordIndex] || now - AppChordRender._download[chordIndex] > 1000)) {
      AppChordRender._download[chordIndex] = now;
      // AppChordRender._chordConfig[chord] = null;
      const encoded = chordIndex.replace('#', '%23').replace("/", "_");
      const url = '/assets/chords/' + encoded + '.json';
      this.http.get<Chord>(url)
        .subscribe(
          (data: Chord) => {
            console.info('Loaded chord', chordIndex, data);
            AppChordRender._chordConfig[chordIndex] = data;
            this.enrichChord(chordname);
            console.info(chordIndex, AppChordRender._chordConfig[chordIndex]);
          },
          (error: any) => {
            console.info('Failed to load chord', chordIndex, url, error, );
            this.enrichChord(chordname);
            console.info(chordIndex, AppChordRender._chordConfig[chordIndex]);
          }
        );
    } else {
      // console.warn('Chord is loading or already loaded', chord);
    }
  }

  private enrichChord(chordname: string = 'U') {
    let chordIndex = this.getChordIndex(chordname);

    let combi: Chord = {
      ...{ name: this.chord, placement: {} },
      ...AppChordRender._chordConfig[chordIndex]
    }
    AppChordRender._chordConfig[chordIndex] = combi;
    let placement: {[index:string]: FingerPlacement[]} = {};
    Object.keys(ChordCalc.init).forEach((instrument: string) => {
      const calc = ChordCalc.init[instrument](this.chord);
      calc.level = this.level - 1;
      placement[instrument] = calc.fingerPlacement;
    })
    combi.placement = {
      ...placement,
      ...AppChordRender._chordConfig[chordIndex].placement,
    }
    AppChordRender._chordConfig[chordIndex] = combi;
  }

  public get strings(): number[] {
    switch (this.instrument) {
      case 'ukulele':
        return [0, 1, 2, 3];
      case 'guitar':
      default:
        return [0, 1, 2, 3, 4, 5];
    }
  }

  public get stringSpace(): number {
    return (this.width - this.stringOffset * 0.5) / (this.strings.length);
  }
  public get stringOffset(): number {
    return 20;
  }

  public get fretSpace(): number {
    return (this.height - this.fretOffset * 0.5) / (this.frets.length + 1);
  }

  public get fretOffset(): number {
    return 20;
  }

  public get chordConfig(): Chord | null {
    this.loadChord(this.chord);
    return AppChordRender._chordConfig[this.getChordIndex(this.chord)];
  }

  public get name(): string {
    if (!this.chordConfig) {
      return '';
    }
    return this.chordConfig.name.replace('_', '/') +
      (this.level !== 1 ? '+' + this.level : '');
  }

  public get fingerPlacement(): FingerPlacement[] {
    if (!this.chordConfig || !this.chordConfig.placement || !this.chordConfig.placement[this.instrument]) {
      return ChordCalc.init[this.instrument](this.chord).fingerPlacement;
    }
    return this.chordConfig.placement[this.instrument];
  }
}
